import React, { useState, useRef } from 'react';
import Modal from '../ProfileV2/shared/Modal';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import Fetch from '@components/util/Fetch';

import './styles.scss';

const PrimeTermsModal = ({ data }) => {
  const {
    agreements,
    acceptPath,
  } = data;

  const [isOpen, setIsOpen] = useState(true);
  const buttonRef = useRef(null);

  const dismiss = () => {
    logCrmEvent('disruptor_dismissed', { type: 'prime_terms' });
    close();
  }

  const close = () => {
    setIsOpen(false);
  }

  const submit = async () => {
    buttonRef.current.classList.toggle('submitting');
    buttonRef.current.disabled = true;

    const payload = {
      terms_agree: true,
      legal_agreement_uuid: agreements[0].uuid,
    };

    const resp = await Fetch.post({ url: acceptPath, payload });

    if (resp.error) {
      alert(resp.error);
    } else {
      logCrmEvent('disruptor_submitted', { type: 'prime_terms' });

      if (resp.redirectPath) {
        window.location = resp.redirectPath;
      } else {
        close();
        if (window.updateNotice) {
          window.updateNotice(
            {
              header: 'Success!',
              message: "You've accepted the ReferralExchange PRIME Terms",
            },
            5000,
          );
        }
      }
    }

    if (!resp.redirectPath) {
      buttonRef.current.classList.toggle('submitting');
      buttonRef.current.disabled = false;
    }
  };

  return (
    <Modal
      close={dismiss}
      id="prime-terms-modal"
      status={isOpen ? 'active' : 'hidden'}
    >
      <div className="prime-terms-modal edit-modal-inner">
        <div className="agreement-content">
          <h2 className="headline-2">Prime Supplemental Terms</h2>
          <p className="large-slim-font margin-bottom-8">
            Please review and accept the Prime Supplemental Terms.
          </p>
          <div className="terms-wrapper">
            <div dangerouslySetInnerHTML={{ __html: agreements[0].content_html }} />
          </div>
        </div>
        <div className="agreement-actions">
          <div className="button-container">
            <button
              ref={buttonRef}
              type="submit"
              className="profile-edit-button large submit"
              onClick={submit}
            >
              <i className="fa-solid fa-spin spinner-third" />
              <i className="check-circle" />
              <span className="default-text">I agree to the ReferralExchange Agent Terms</span>
              <span className="submit-text">Submitting</span>
            </button>
            <button
              id="terms-close-button"
              type="submit"
              className="profile-edit-button large transparent"
              onClick={dismiss}
            >
              I&apos;ll do it later
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PrimeTermsModal;
